import { combineReducers } from 'redux'
import messagesSlice from './messagesSlice'

export default combineReducers({
    messages: messagesSlice
})
